module.exports = "<div class=\"home-block row\">\r\n    Formulaire de création d'une démarche\r\n</div>      "